// extracted by mini-css-extract-plugin
export default {"Showcase":"Showcase_Showcase__xJrWj"};